import React, { Component } from "react";
import { Form, Validators } from "../../components/form/DynamicFormTs";
import { withRouter } from "react-router-dom";
import { DynamicForm } from "../../components/form/DynamicForm";
import {
   Button,
   CircularProgress,
} from "@material-ui/core";
import ACCESS from "../../ACCESS";
import { AuthContext } from "../../context/authContext";
import Toast from "react-hot-toast";
import Http from "../../Http";

class EADCancel extends Component {
   idEAD = isNaN(this.props.id) ? null : this.props.id;

   state = {
      guias: [],
      FormData: new Form(
         [
            Form.Field("text", "id_ead", "Folio EAD", this.idEAD, [], 6, [], [], [], false, true),
            Form.Field("select", "id_motivo_ead", "Motivo Incumplida", null, [Validators.required], 6),
            Form.Field("textarea", "descripcion", "Descripcion Breve", "", [Validators.required], 12),
         ], [],
         `Cita Incumplida #${this.idEAD}`
      ),
      loadingData: true,
      loadingError: '',
      disabled: false,

      saving: false,
   };

   componentDidMount() {
      const { hasAccess } = this.context;
      if (this.idEAD) {
         this.LoadForm().then(d => {
            this.setState({ loadingData: false, });
         }).catch(() => {
            this.setState({ loadingError: 'Error al cargar', loadingData: false });
         })
      } else {
         this.setState({ loadingData: false });
      }
   }

   LoadForm = async (id = null) => {
      let { FormData } = this.state;
      let { hasAccess } = this.context;
      try {
         let Res = await Http.get(`ead/form`);
         if (!Res.error) {
            const { ead_motivos } = Res.data;
            let newForm = { ...FormData };
            newForm = Form.FieldOptions(newForm, 'id_motivo_ead', ead_motivos, 'id', 'descripcion');

            this.setState({
               FormData: Form.Patch(newForm, Res.data, true),
            });
            return Res.data;
         } else {
            this.setState({ loadingError: 'Error al cargar informacion(1)', loadingData: false });
         }
      } catch (error) {
         this.setState({ loadingError: 'Error al cargar informacion(2)', loadingData: false });
      }
      return null;
   }

   formChange = async (form, field, type) => {
      let newForm = { ...form };

      this.setState({ FormData: newForm });
   }

   incumplirEAD = async (e) => {
      const { saving, FormData } = this.state;
      e.preventDefault();
      if (saving) return;
      let valid = Form.ValidateForm(FormData);
      if (valid !== true) return Toast.error(`Error en el campo '${valid.name}'`);
      let values = Form.FieldsValues(FormData);

      this.setState({ saving: true });
      const res = Http.post('ead/incumplida', {
         id_ead: values.id_ead,
         id_motivo_ead: values.id_motivo_ead,
         descripcion: values.descripcion,
      });

      res.then(data => {
         if (data.error) return Toast.error(`Error al guardar datos ${data.errMsg || ''}`);
         Toast.success(`Se ha marcado como incumplida la cita. folio ead #${values.id_ead}`);
         this.props.onCancel();
      }).catch((err) => {
         console.error({err})
         return Toast.error('Error inesperado al marcar como incumplida la cita (EAD-99)')
      }).finally(() => {
         this.setState({ saving: false });
      });
   }

   render() {
      const {
         FormData,
         loadingData,
         loadingError,
         disabled,
         saving
      } = this.state;
      const { hasAccess } = this.context;

      if (loadingData) {
         return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
            <CircularProgress size={"50px"} color="primary" />
            <div><h3>Cargando...</h3></div>
         </div>
      }

      if (loadingError) {
         return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
            <h3>{loadingError}</h3>
         </div>
      }

      return (
         <div>
            <DynamicForm
               form={FormData}
               disabled={disabled}
               formChange={this.formChange}
               // onSubmit={this.onSubmit}
            />
            <div style={{
               display: 'flex',
               width: '100%',
               justifyContent: 'flex-end',
               padding: 5,
            }} >
               <Button
                  variant='contained'
                  style={{ marginRight: 10 }}
                  onClick={this.props.onClose}>
                  {`Cerrar`}
               </Button>
               <Button
                  variant='contained'
                  onClick={this.incumplirEAD}
                  disabled={saving}
                  color='primary'>
                  {saving && <CircularProgress size={20} style={{ marginRight: 5 }} />}
                  {`Marcar como incumplida`}
               </Button>
            </div>
         </div>
      );
   }
}

EADCancel.contextType = AuthContext;
export default withRouter(EADCancel);